module.exports = __webpack_public_path__ + "media/images/gc_camera_icon-17c033913ae78eb06dc9a4b84a6a473c.png";